import React, { useContext } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { MessageLines } from './blocks';
import { PlanningNotificationContext } from './context';

// Renders the board-wide toast off the notification context so a
// setNotification/setError tick repaints only this component, not the board.
// `message` is a string, or a list of lines that each get their own row.
const PlanningNotification = () => {
    const { notification, setNotification } = useContext(PlanningNotificationContext);

    return (
        <Snackbar
            open={!!notification?.message}
            onClose={() => setNotification(null)}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            autoHideDuration={10000}
        >
            <Alert
                onClose={() => setNotification(null)}
                severity={notification?.severity}
                elevation={6}
                variant="filled"
            >
                {Array.isArray(notification?.message) ? (
                    <MessageLines lines={notification.message} />
                ) : (
                    notification?.message
                )}
                {notification?.clickable && notification.clickable}
            </Alert>
        </Snackbar>
    );
};

export default React.memo(PlanningNotification);
